import { BiError } from "react-icons/bi";
import { MdOutlineKeyboardBackspace } from "react-icons/md";
import { IoPersonAddSharp } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { FaPhoneAlt } from "react-icons/fa";
import { AiFillSignature } from "react-icons/ai";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { useState } from 'react';
import './App.css';
import { InputMask } from "primereact/inputmask";
import { FloatLabel } from 'primereact/floatlabel';
import { useNavigate } from "react-router-dom";
import { useAuth } from "./auth/AuthProvider";
import { BsPersonVcardFill } from "react-icons/bs";
import { InputText } from "primereact/inputtext";
import Title from "./components/Title";
import Panel from "./components/Panel";
import { Button } from "primereact/button";
import { ProgressSpinner } from "primereact/progressspinner";
import { BiLogInCircle } from "react-icons/bi";
import { confirmDialog, ConfirmDialog } from "primereact/confirmdialog";
import { Dialog } from "primereact/dialog";
import { GiHouseKeys } from "react-icons/gi";
import * as API from './services/API';
function LostPass() {
  const [cpf, setCPF] = useState('')
  const [celular, setCelular] = useState('')

  const navigate = useNavigate();
  const authenticator = useAuth()
  const [loading, setLoading] = useState(false)
  const [subject, setSubject] = useState('')
  const [message, setMessage] = useState(<></>)
  const [visible, setVisible] = useState(false)
  const showMessage = (subject: string, message: any) => {
    setSubject(subject)
    setMessage(<>{message}</>)
    setVisible(true)
  }

  const reset = async () => {
    setLoading(true)
    try {
      const response = await API.resetPassword(cpf, celular)
      const data = await response.json()
      if (response.ok) {
        showMessage('Sucesso', data.message)
        setCPF('')
        setCelular('')
      }
      else {
        showMessage('Erro', <><BiError /> {data.error}</>)
      }
    } catch (error) {
      console.log('Erro', error)
      showMessage('Erro', <><BiError /> Erro desconhecido</>)
    }
    setLoading(false)
  }
  const title = (
    <Title
      title='RECUPERAÇÃO DE SENHA'
      subtitle='Informe seus dados corretamente'
      icon={() => <GiHouseKeys size={32} />}
    />
  )

  const footer = (
    <>
      <Button severity='success' style={{ display: 'flex', justifyContent: 'center', width: '100%' }} onClick={reset} disabled={cpf.length < 14 || celular.length < 15 || loading}>
        {loading ? <ProgressSpinner style={{ width: '32px', height: '32px' }} /> : <>RECUPERAR <BiLogInCircle size={24} style={{ marginLeft: 10 }} />
        </>}
      </Button>
      <Button severity='secondary' style={{ display: 'flex', justifyContent: 'center', width: '100%', marginTop: 5 }}
        onClick={() => navigate('/')}
      >
        VOLTAR <MdOutlineKeyboardBackspace style={{ marginLeft: 10 }} />
      </Button>
    </>
  )

  const confirm1 = () => {
    confirmDialog({
      group: 'headless',
      message: 'Senha nova criada e enviada!',
      header: 'Recuperação de senha',
      icon: 'pi pi-exclamation-triangle',
      defaultFocus: 'accept',
      accept: () => { console.log('a') },
      // reject: () => { console.log('b') }
    });
  };


  return (
    <div style={{ border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#999999' }}>
      <Panel title={() => title} footer={() => footer} >
        <Dialog header={subject} visible={visible} style={{ width: '50vw' }} onHide={() => { if (!visible) return; setVisible(false); }}>
          {/* <p className="m-0"> */}
          {message}
          {/* </p> */}
        </Dialog>
        {/* <ConfirmDialog /> */}
        {/* <ConfirmDialog
          group="headless"
          content={({ headerRef, contentRef, footerRef, hide, message }) => (
            <div className="flex flex-column align-items-center p-5 surface-overlay border-round">
              <div className="border-circle bg-primary inline-flex justify-content-center align-items-center h-6rem w-6rem -mt-8">
                <i className="pi pi-question text-5xl"></i>
              </div>
              <span className="font-bold text-2xl block mb-2 mt-4" ref={headerRef}>
                {message.header}
              </span>
              <span className="mb-0" ref={contentRef}>
                {message.message}
              </span>
              <span className="flex align-items-center gap-2 mt-4" ref={footerRef}>
                <Button
                  label="Save"
                  onClick={(event) => {
                    hide(event);
                    // accept();
                  }}
                  className="w-8rem"
                ></Button>
                <Button
                  label="Cancel"
                  outlined
                  onClick={(event) => {
                    hide(event);
                    // reject();
                  }}
                  className="w-8rem"
                ></Button>
              </span>
            </div>
          )}
        /> */}

        <div className="p-inputgroup flex-1" style={{ marginTop: 10 }}>
          <span className="p-inputgroup-addon">
            <BsPersonVcardFill />
          </span>
          <FloatLabel>
            <InputMask id="cpf_input" value={cpf} onChange={(e: any) => setCPF(e.target.value)} mask="999.999.999-99" />
            <label htmlFor="cpf_input">CPF</label>
          </FloatLabel>
        </div>

        <div className="p-inputgroup flex-1" style={{ marginTop: 30 }}>
          <span className="p-inputgroup-addon">
            <FaPhoneAlt />
          </span>
          <FloatLabel>
            <InputMask id="celular_input" value={celular} onChange={(e: any) => setCelular(e.target.value)} mask="(99) 99999-9999" />
            <label htmlFor="celular_input">CELULAR</label>
          </FloatLabel>
        </div>


      </Panel>
      {/* <Card title={} header={header} footer={footer}>
      </Card> */}
    </div>
  );
}

export default LostPass;
